/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import { alertController } from '@ionic/vue';
import secureLsService from '../services/secureLs.service';
import AppConst from '../constants/app.constant';

const openUcSet = () => {
  alertController
    .create({
      header: 'Create UC',
      backdropDismiss: 'false',
      inputs: [
        {
          name: 'email',
          placeholder: 'email',
          type: 'string',
        },
        {
          name: 'password',
          placeholder: 'password',
          type: 'string',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
        },
        {
          text: 'Create UC',
          handler(data) {
            if (data.email && data.password) {
              secureLsService.setInfo(
                AppConst.localstorageConf.uc_copy,
                {
                  Username: data.email,
                  Password: data.password,
                },
              );
            }
          },
        },
      ],
    })
    .then((alert) => {
      alert.present();
    });
};

export { openUcSet };
